import {createFeatureSelector, createSelector} from "@ngrx/store";
import {accountAchievementFeatureKey} from "./account-achievements.reducer";
import {AccountAchievement} from "../../models/AccountAchievement";

export const accountAchievementsSelector = createFeatureSelector<AccountAchievement[]>(accountAchievementFeatureKey);
